import {
  Card as MantineCard,
  CardProps,
  Stack,
  StackProps,
} from "@mantine/core"
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react"

import {
  SectionHeader,
  SectionHeaderProps,
} from "../SectionHeader/SectionHeader.tsx"

import styles from "./Card.module.css"

type Props = {
  children: ReactNode
} & CardProps &
  Omit<
    Omit<
      DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
      "ref"
    >,
    "component" | keyof CardProps
  >
export const Card = ({ children, ...props }: Props) => {
  return (
    <MantineCard withBorder {...props} className={styles.card}>
      {children}
    </MantineCard>
  )
}

type CardHeaderProps = {
  children?: ReactNode
} & SectionHeaderProps

Card.Header = ({ children, ...props }: CardHeaderProps) => {
  return <SectionHeader {...props}>{children}</SectionHeader>
}

// Subcomponent for Card Body
type CardBodyProps = {
  children: ReactNode
} & StackProps

Card.Section = ({ children, ...props }: CardBodyProps) => {
  return (
    <Stack gap="var(--tfg-organism-padding-y)" {...props}>
      {children}
    </Stack>
  )
}
